import { useBillingStatusStore } from './billing-status'
import { useActiveModelStore } from './modal'
import { useProgressTrackerStore } from './progress-tracker'
import { useUserStore } from './user'
import { useWebSocketStore } from './websocket'

/**
 * Function to clear all stores and reset them to their initial values
 */
export const clearAllStores = () => {
  // Get all store instances and reset them
  const userStore = useUserStore.getState()
  const modalStore = useActiveModelStore.getState()
  const billingStore = useBillingStatusStore.getState()
  const progressStore = useProgressTrackerStore.getState()
  const websocketStore = useWebSocketStore.getState()

  // Reset all stores
  userStore?.reset?.()
  modalStore?.reset?.()
  billingStore?.reset?.()
  progressStore?.reset?.()
  websocketStore?.reset?.()
}

/**
 * Hook to access the clearAllStores function
 */
export const useClearStores = () => {
  return { clearAllStores }
}
